interface MessageTemplate {
  body: string;
  minStreak?: number;
}

const MESSAGES: MessageTemplate[] = [
  // Motivational
  { body: "If you don't figure out how to make money while you sleep, you'll work forever!" },
  { body: "Learn a stock a day to find potential winners!" },
  { body: "The best investment you can make is in yourself. Time for today's puzzle!" },
  { body: "Compound your knowledge daily. Today's stock is ready!" },

  // FOMO
  { body: "Today's stock is waiting. Can you guess it?" },
  { body: "A new daily stock just dropped. How many guesses will it take?" },
  { body: "The market never sleeps and neither does your daily puzzle!" },

  // Finance quotes
  { body: "Warren Buffett reads 500 pages a day. You just need to guess one stock." },
  { body: "Peter Lynch said 'Know what you own.' Start with today's stock!" },
  { body: "The stock market is a device for transferring money from the impatient to the patient." },

  // Educational
  { body: "Every stock you learn is one more you might spot in the wild!" },
  { body: "Can you read today's chart and figure out the company?" },

  // Streak-specific
  { body: "Your {streak}-day streak is on fire! Don't let it die!", minStreak: 2 },
  { body: "{streak} days strong! Keep the momentum going!", minStreak: 3 },
  { body: "{streak} days and counting. Legendary investor energy.", minStreak: 14 },
  { body: "You've played {streak} days straight. Warren Buffett would be proud.", minStreak: 7 },
  { body: "{streak}-day streak! You're building real market knowledge.", minStreak: 5 },
];

/**
 * Select a notification message for the given date and streak.
 * Deterministic: same date + streak always returns the same message.
 */
export function selectMessage(streak: number): string {
  const now = new Date();
  const dayIndex = now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();

  const eligible = MESSAGES.filter(m => !m.minStreak || streak >= m.minStreak);
  if (eligible.length === 0) return MESSAGES[0].body;

  const selected = eligible[dayIndex % eligible.length];
  return selected.body.replace(/\{streak\}/g, String(streak));
}
